export {
  default,
  ModalContextProvider,
  defaultContext as defaultModalContext,
  type OwnProps as ModalContextProps
} from './ModalContext';
